"use client"

import type { FormEventHandler, FunctionComponent } from "react"

import { useEffect, useRef } from "react"

import { Button } from "@jobteaser/spark/components/Button"
import { Search } from "@jobteaser/spark/components/Icons/Search"

import { useLocale } from "@/modules/locales/useLocale"
import { useTracking } from "@/modules/tracking/useTracking"

import styles from "./SearchBar.module.css"

type SearchBarProps = {
  buttonLabel: string
  searchPlaceholder: string
}

export const SearchBar: FunctionComponent<SearchBarProps> = ({ buttonLabel, searchPlaceholder }) => {
  const locale = useLocale()
  const tracking = useTracking()
  const ref = useRef<HTMLFormElement>(null)

  useEffect(() => {
    const input = document.getElementById("homePageSearchInput") as HTMLInputElement
    if (input) {
      input.addEventListener("focus", event => {
        const target = event.target as HTMLInputElement
        target.placeholder = ""
      })

      input.addEventListener("blur", event => {
        const target = event.target as HTMLInputElement

        if (!target.value) {
          target.placeholder = searchPlaceholder
        }
      })
    }
  }, [searchPlaceholder])

  const handleSubmit: FormEventHandler<HTMLFormElement> = event => {
    event.preventDefault()

    if (!ref.current) {
      return
    }

    tracking?.setRefererParams(
      {
        from_feature: "homepage",
        is_from_b2c_homepage: true,
        module: "fo_homepage",
        role: "search_bar_click",
      },
      { keyName: `/${locale}/job-offers` }
    )

    ref.current.submit()
  }

  return (
    <form action={`/${locale}/job-offers`} method="GET" onSubmit={handleSubmit} ref={ref}>
      <div className={styles.searchContainer}>
        <div className={styles.inputContainer}>
          <Search className={styles.searchIcon} />
          <input
            className={styles.searchInput}
            id="homePageSearchInput"
            name="q"
            placeholder={searchPlaceholder}
            required
            type="text"
          />
        </div>
        <Button className={styles.searchButton} type="submit" variant="highlight">
          {buttonLabel}
        </Button>
      </div>
    </form>
  )
}
